import React, { useState } from "react";
import plus from "../../assets/images/Icon feather-plus.png";
export default function ImageInput({ src, radiusPercentage = 0 }) {
  const [source, setSource] = useState(src);

  const inner = {
    display: "block",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
  };
  const Styles = {
    theImageUploader: {
      position: "relative",
      overflow: "hidden",
      width: "100%",
      height: "100%",
      borderRadius: `${radiusPercentage}%`,
      backgroundImage: `url(${source})`,
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
    },
    input: {
      ...inner,
      display: "none",
    },
    overlay: {
      ...inner,
      backgroundColor: "rgb(180, 180, 180, 0.4)",
    },
    label: {
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: `${radiusPercentage}%`,
      cursor: "pointer",
    },
    icon: { color: "rgb(124, 124, 124)", fontSize: "4em" },
    image: {
      ...inner,
      zIndex: -1,
      userSelect: "none",
    },
  };

  return (
    <>
      <div style={Styles.theImageUploader}>
        <input
          type="file"
          id="uploader"
          style={Styles.input}
          onChange={(e) => {
            let fileSource =
              e.target.files.length > 0
                ? URL.createObjectURL(e.target.files[0])
                : null;
            setSource(fileSource);
          }}
        />
        <div style={Styles.overlay}>
          <label style={Styles.label} htmlFor="uploader">
            <img className="plus" src={plus} alt="plus" style={Styles.icon} />
          </label>
        </div>
      </div>
    </>
  );
}
